import { UserGroup } from './types';

// Cada perfil aceita o nome padronizado (`Plataforma | Perfil`) e o antigo enquanto
// os grupos são renomeados na Authorization Extension. Tokens emitidos antes do
// rename seguem com o nome antigo até expirar; depois disso o antigo pode sair.
export const SALES_GROUPS = {
  superAdmin: ['Vendas | Admin Especial', 'Admin Especial de Vendas'],
  admin: ['Vendas | Admin', 'Vendas Admin'],
} as const satisfies Record<string, readonly UserGroup[]>;

export type SalesProfile = keyof typeof SALES_GROUPS;

export const hasSalesGroup = (groups: readonly string[] | undefined, profile: SalesProfile): boolean =>
  groups?.some((group) => (SALES_GROUPS[profile] as readonly string[]).includes(group)) ?? false;
